module.exports = __webpack_public_path__ + "static/img/8.83f22cd5.png";